// extracted by mini-css-extract-plugin
export default {"highlight":"styles_highlight__7jDDW","action_required":"styles_action_required__SDOvz"};